import React, { useContext } from 'react';
import './Video.scss';
import { layoutContext } from '../../CloudPakForAiops';
import { Scenario } from '../../../data/constants';

const Video = () => {
  const { currentVideo } = useContext(layoutContext);
  const { setCurrentScenario } = useContext(layoutContext);
  return (
    <>
      <div className="cloud-pak-for-aiops_video-wrapper">
        <button
          onClick={() => {
            setCurrentScenario(Scenario.sidebar);
          }}
        >
          x
        </button>
        <iframe src={currentVideo} />
      </div>
    </>
  );
};

export default Video;
